export default __webpack_public_path__ + "static/optional_steps_weatherization-4a417a977a917a20d27f3187dca1b423.png";